export function numberWithCommas(x) {
  if (x) {
    const parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (parts[1]) {
      parts[1] = (parts[1].length === 1) ? parts[1] + '0' : parts[1];
    } else {
      parts[1] = '00';
    }
    return parts.join('.');
  }
  return '0';
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/numberWithCommas.jsx